import { useIsMobile } from '@bbl-digital/snorre-v2'
import { FC, useEffect, useState } from 'react'
import { EventData, Step } from 'react-joyride'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import {
  GUIDES_COMPLETED_REQUESTED,
  GUIDE_COMPLETED_REQUESTED,
} from 'shared/store/guides/actionTypes'
import { getGuides } from 'shared/store/guides/selectors'
import { getUser } from 'shared/store/user/selectors'
import { getClientIdsForUser } from 'shared/utils/rolesHelper'
import {
  ONBOARDING_GUIDE_ID,
  RELATIONPICKER_GUIDE_ID,
} from '../shared/constants/guides'
import JoyrideDefault from '../shared/components/JoyrideDefault'
import {
  guideIsCompleted,
  guidesAreCompleted,
  isAllGuidesSkipped,
} from '../shared/utils/guide-helper'
import useOnboardingSteps from './useOnboardingSteps'

const OnBoardingGuide: FC = () => {
  const dispatch = useAppDispatch()
  const isMobile = useIsMobile()
  const { data } = useAppSelector(getGuides)
  const { data: user } = useAppSelector(getUser)
  const {
    mainmenustep,
    mysiteshortcutstep,
    relationpickerstep,
    welcomestep,
    getOnboardingMobileSteps,
  } = useOnboardingSteps()

  const [steps, setSteps] = useState<Step[] | undefined>()

  useEffect(() => {
    if (!data || !user?.roles) return

    if (isAllGuidesSkipped(data)) setSteps(undefined)

    if (
      guidesAreCompleted(data, [
        ONBOARDING_GUIDE_ID,
        RELATIONPICKER_GUIDE_ID,
      ]) ||
      isAllGuidesSkipped(data)
    ) {
      setSteps(undefined)
      return
    }
    if (isMobile) {
      if (!guideIsCompleted(data, ONBOARDING_GUIDE_ID))
        setSteps(getOnboardingMobileSteps(user.roles))
    } else {
      const stepsarr: Step[] = []
      if (!guideIsCompleted(data, ONBOARDING_GUIDE_ID))
        stepsarr.push(welcomestep, mainmenustep, mysiteshortcutstep)

      if (
        getClientIdsForUser(user.roles).length > 1 &&
        !guideIsCompleted(data, RELATIONPICKER_GUIDE_ID)
      )
        stepsarr.push(relationpickerstep)

      setSteps(stepsarr)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, user?.roles])

  const onEvent = (e: EventData) => {
    if ((e.action === 'close' || e.action === 'reset') && data) {
      if (isMobile) {
        dispatch({
          type: GUIDE_COMPLETED_REQUESTED,
          payload: ONBOARDING_GUIDE_ID,
        })
      } else {
        const ids: string[] = []
        if (!guideIsCompleted(data, ONBOARDING_GUIDE_ID))
          ids.push(ONBOARDING_GUIDE_ID)

        if (!guideIsCompleted(data, RELATIONPICKER_GUIDE_ID))
          ids.push(RELATIONPICKER_GUIDE_ID)

        dispatch({
          type: GUIDES_COMPLETED_REQUESTED,
          payload: ids,
        })
      }
      setSteps(undefined)
    }
  }

  return steps ? (
    <JoyrideDefault steps={steps} onEvent={onEvent} disableScrolling />
  ) : null
}

export default OnBoardingGuide
